<template>
    <li class="menu-item-li"
        :class="{ 'unavalible': item.available_for_order === 0 }">
        <div class="menu-item-wrap"
             @click="openFullItem">
            <div class="menu-item-info">
                <div class="menu-item-name">{{ item.name }}</div>
                <div class="menu-item-description">{{ item.description }}</div>
                <div class="menu-item-footer">
                    <span class="menu-item-price">{{ item.price }} zł</span>
                    <span class="menu-item-icons">
                        <IconGluttenFreeOutline v-if="item.is_gluten_free"
                                                width="20"
                                                height="20"
                                                @click.native.stop="showIconDetails('gluten-free')" />
                        <IconPepperHot v-if="item.is_spicy"
                                       width="20"
                                       height="20"
                                       @click.native.stop="showIconDetails('chili-pepper')">
                        </IconPepperHot>
                        <IconVegetarian v-if="item.is_vegetarian"
                                        width="20"
                                        height="20"
                                        @click.native.stop="showIconDetails('vegeterian')">
                        </IconVegetarian>
                        <IconLowCal v-if="item.is_low_calorie"
                                    width="20"
                                    height="20"
                                    @click.native.stop="showIconDetails('low-calories')">
                        </IconLowCal>
                    </span>
                </div>
            </div>

            <div class="menu-item-image-wrap">
                <img v-if="!!item.image"
                     :src="item.image"
                     :alt="item.name">
                <img v-else
                     src="@/assets/img/menus/pic1.jpg"
                     :alt="item.name">

                <div class="menu-item-add"
                     v-if="canOrder">
                    <IconPlus />
                </div>
            </div>
        </div>
        <DishDetails v-if="showFullItem"
                     ref="detailsRef"
                     v-model="showFullItem"
                     :dish-id="item.id"
                     :dish="item" />
        <FoodIconInfoPopup ref="iconDetails"
                           :icon="activeIcon" />
    </li>
</template>

<script>
import IconGluttenFreeOutline from '@/components/icons/IconGluttenFreeOutline.vue';
import IconPepperHot from '@/components/icons/IconPepperHot.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import IconVegetarian from '@/components/icons/IconVegetarian.vue';
import IconLowCal from '@/components/icons/IconLowCal.vue';
import DishDetails from '@/modules/dishDetails/DishDetails.vue';
import FoodIconInfoPopup from "@/components/FoodIconInfoPopup.vue";

export default {
    name: "MenuItem",
    components: {
        IconGluttenFreeOutline,
        IconPepperHot,
        IconVegetarian,
        IconPlus,
        IconLowCal,
        DishDetails,
        FoodIconInfoPopup,
    },
    props: {
        item: { type: Object, required: true },
    },
    data() {
        return {
            showFullItem: false,
            activeIcon: null,
        };
    },
    computed: {
        canOrder() {
            const locale = this.$store.getters['getCompanyData'].locale;

            return (locale.activePaymentCredentials || this.$store.getters['getIsModeHOT'] || this.$store.getters['getIsModeSOT'])
                && locale.pos_terminal_enabled
                && locale.smart_menu_cart_enabled;
        },
    },
    methods: {
        openFullItem() {
            this.showFullItem = true;
            this.$nextTick(() => {
                this.$refs.detailsRef.open();
            });
        },
        showIconDetails(icon) {
            this.activeIcon = icon;
            this.$nextTick(() => {
                this.$refs.iconDetails.open();
            });
        },
    }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

.slide-up-enter-active {
    transition: all .4s ease;
}

.slide-up-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-up-enter,
.slide-fade-leave-to {
    transform: translateY(100vh);
    opacity: 0;
}

.menu-item-li {

    margin: 10px 0;
    height: 130px;

    border-bottom: 1px solid #EDEDED;

    &:last-of-type {
        margin-bottom: 0;
    }

    .menu-item-wrap {
        display: flex;
        height: 100%;
    }
}

.unavalible {
    opacity: 0.5;
    pointer-events: none;
}

.menu-item-info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    margin-right: 10px;
    padding: 10px 0;

    .menu-item-name {
        margin-bottom: 4px;

        font-weight: 700;
        font-size: 16px;
        line-height: 20px;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        color: black;
    }

    .menu-item-description {
        margin-bottom: auto;

        font-size: 13px;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

        color: black;
    }
}

.menu-item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .menu-item-price {
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        text-align: center;

        color: $color_blue_cornflower;
    }

    .menu-item-icons {
        display: flex;
        gap: 8px;
    }

}

.menu-item-image-wrap {
    position: relative;

    flex-shrink: 0;

    margin: auto 0;
    width: 110px;
    height: 110px;

    .menu-item-add {
        display: flex;

        position: absolute;
        bottom: 6px;
        right: 6px;

        border-radius: 6px;

        box-shadow: 0px 1px 10px 0px #0000001A;
        background-color: white;
    }

    img {
        width: 100%;
        height: 100%;

        object-fit: cover;

        border-radius: 8px;

        // filter: drop-shadow(0px 1000px 0 red);
        // transform: translateY(-1000px);
    }
}

.menu-item-icon-popup {
    margin-bottom: 30px;
    padding: 0 30px 30px;

    text-align: center;
}
</style>
